<div class="block">
    <div class="row">
        <div class="col-paginator-fixed">
        <mat-paginator [length]="pagination.totalCount"
                           [hidePageSize]="false"
                           [pageSize]="pagination.pageSize"
                           [pageIndex]="pagination.currentPage"
                           [pageSizeOptions]="[5, 10, 20]"
                           (page)="selectPage($event)"
                           [showFirstLastButtons]="true">
            </mat-paginator>
        </div>
        <div class="col-status-fixed">
            <mat-select [(value)]="status"
                        (valueChange)="selectStatus()"
                        placeholder="* Status">
                <mat-option value="">All</mat-option>
                <mat-option value="FUTURE">Future</mat-option>
                <mat-option value="ACTIVE">Active</mat-option>
                <mat-option value="EXPIRED">Expired</mat-option>
            </mat-select>
        </div>
    </div>
</div>
